module.exports = __webpack_public_path__ + "media/images/game_icon/en/AB1020-4f6e0ea257450ddf1f1864e45e536a70.png";